const benefits = [
  {
    icon: "ri-money-dollar-circle-line",
    iconBg: "bg-brand/10",
    iconColor: "text-brand",
    title: "Zero Annual Filter Costs",
    desc: "No disposable filters to buy — ever. Save $80–$200 every year compared to traditional HEPA purifiers.",
    stat: "$0",
    statLabel: "Annual cost",
  },
  {
    icon: "ri-leaf-line",
    iconBg: "bg-emerald-100",
    iconColor: "text-emerald-600",
    title: "Zero Waste",
    desc: "No disposable filters means no landfill contribution. Every plate is washable and reusable for life.",
    stat: "0 lbs",
    statLabel: "Waste/year",
  },
  {
    icon: "ri-water-flash-line",
    iconBg: "bg-brand/10",
    iconColor: "text-brand",
    title: "5-Min Maintenance",
    desc: "Rinse the collecting plates under warm water every few months. No tools, no hassle needed.",
    stat: "5 min",
    statLabel: "To clean",
  },
  {
    icon: "ri-flashlight-line",
    iconBg: "bg-amber-100",
    iconColor: "text-amber-600",
    title: "Low Energy Use",
    desc: "Airdog TPA runs on less power than conventional HEPA purifiers — cleaner air without a bigger bill.",
    stat: "50%",
    statLabel: "Less energy",
  },
];

export default function WasteFreeSection() {
  return (
    <section id="sustainability" className="min-h-[50vh] md:min-h-[60vh] flex flex-col justify-center bg-[#FAF8F5] py-6 md:py-10 scroll-mt-20 overflow-hidden relative z-0">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl w-full">

        {/* Header */}
        <div className="mb-6 md:mb-8 text-center max-w-3xl mx-auto">
          <span className="inline-block text-xs md:text-sm font-bold tracking-[0.2em] uppercase text-brand mb-3">
            Sustainability
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-gray-900 leading-tight">
            Waste-Free Filter-Free Forever
          </h2>
        </div>

        {/* Two-column */}
        <div className="grid lg:grid-cols-5 gap-4 md:gap-6 items-center">

          {/* Left — 4 benefit cards */}
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
            {benefits.map((b, i) => (
              <div
                key={i}
                className="flex items-start gap-2.5 bg-white rounded-xl p-3 md:p-4 border border-gray-100 hover:border-brand/15 transition-colors duration-200 cursor-default"
              >
                <div className={`w-9 h-9 rounded-lg ${b.iconBg} flex items-center justify-center shrink-0`}>
                  <i className={`${b.icon} ${b.iconColor} text-sm`} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-black text-gray-900 mb-0.5">{b.title}</h3>
                  <p className="text-[11px] text-gray-700 leading-snug font-bold">{b.desc}</p>
                </div>
                <div className="shrink-0 text-right hidden sm:block">
                  <div className="text-sm font-black text-brand leading-none">{b.stat}</div>
                  <div className="text-[10px] text-gray-600 font-bold mt-0.5 whitespace-nowrap">{b.statLabel}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Right — product image */}
          <div className="lg:col-span-2">
            <div className="relative w-[52%] mx-auto">
              <img
                src="https://horizons-cdn.hostinger.com/d6001238-3821-4bad-b299-240d4c871593/airdog-2-s9Tz1.png"
                alt="Airdog air purifier with washable collecting plates"
                className="w-full h-auto rounded-2xl max-h-[65vh] object-contain"
              />
              <div className="absolute -top-2 -right-2 bg-white rounded-lg px-3 py-2 border border-gray-100">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-md bg-emerald-100 flex items-center justify-center">
                    <i className="ri-recycle-line text-emerald-600 text-sm" />
                  </div>
                  <div>
                    <p className="text-xs font-bold text-gray-900 leading-none">Filter-Free</p>
                    <p className="text-[10px] text-gray-500">For life</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}